var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.currentSystem
        ? _c("a-result", {
            attrs: {
              status: "403",
              "sub-title":
                _vm.status[_vm.currentSystem.status] ||
                (_vm.currentSystem.serviceDeploy <= 2
                  ? _vm.serviceDeployError
                  : ""),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "extra",
                  fn: function () {
                    return [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.toHome },
                        },
                        [_vm._v(" 返回首页 ")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4080190858
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }